/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */

// import utils
import client from "@/axiosClient";

// import types
import type { AxiosRequestConfig } from "axios";
import type { MessageSummaryViewModel } from "../types";

export type GetMessageSummaryGetServiceArguments = { limit?: number };

/**
 * Service GetMessageSummaryGetService
 */
export const GetMessageSummaryGetService = (
  { limit }: GetMessageSummaryGetServiceArguments,
  axiosConfig?: AxiosRequestConfig,
) =>
  client<MessageSummaryViewModel>({
    url: `/api/1.0/message/summary`,
    method: "get",
    params: { limit },
    ...axiosConfig,
  });

export default GetMessageSummaryGetService;
